// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__E0wL_","errors":"Errors_errors__2mx3A"};